// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".steps-indicator-container{border-bottom:1px solid #104182}.steps-indicator-container .steps-indicator{column-gap:3rem}@media (max-width: 1699.98px){.steps-indicator-container .steps-indicator .step-indicator:not(.active){display:none !important}}\n", ""]);
// Exports
module.exports = exports;
